import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';

const LinkButton = (props) => {
    const {
        label,
        to,
        buttonStyle = {}
    } = props;

    const history = useHistory();

    return (
        <Button
          variant="contained"
          style={{
            textTransform: "none",
            marginRight: "5%",
            width: 130,
            paddingTop: 3,
            paddingBottom: 3,
            ...buttonStyle
          }}
          color="primary"
          onClick={() => history.push(to)}
        >
          <Typography
            variant="h6"
            style={{ color: "white"}}
          >
            {label}
          </Typography>
        </Button>
    );
}

export default LinkButton;